import { useState, useEffect } from 'react';

const isMobileDevice = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // User Agent checks
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // Tamaño de pantalla como refuerzo (útil en tablets)
  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA || isSmallScreen;
};

const getIsPortrait = () => {
  if (window.screen.orientation && window.screen.orientation.type) {
    return window.screen.orientation.type.startsWith('portrait');
  }
  return window.innerHeight >= window.innerWidth;
};

const useIsMobileAndPortrait = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const [isPortrait, setIsPortrait] = useState(getIsPortrait());

  useEffect(() => {
    const update = () => {
      setIsMobile(isMobileDevice());
      setIsPortrait(getIsPortrait());
    };

    update();

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    if (window.screen.orientation?.addEventListener) {
      window.screen.orientation.addEventListener('change', update);
    }

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      if (window.screen.orientation?.removeEventListener) {
        window.screen.orientation.removeEventListener('change', update);
      }
    };
  }, []);

  return { isMobile, isPortrait };
};

export default useIsMobileAndPortrait;
